import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-grid tw-grid-cols-2 tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioToggleWithLabel = _resolveComponent("StudioToggleWithLabel")!
  const _component_StudioSelect = _resolveComponent("StudioSelect")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Enter Event Experience",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _createVNode(_component_StudioToggleWithLabel, {
        id: "show-onboarding-toggle",
        class: "tw-mb-7",
        label: "Mandatory Attendee Profiles",
        subLabel: _ctx.onboardingSubLabel,
        checked: _ctx.showOnboarding,
        disabled: !_ctx.showAttendeeProfilesEnabled,
        "onUpdate:checked": _ctx.handleShowOnboardingToggle
      }, null, 8, ["subLabel", "checked", "disabled", "onUpdate:checked"]),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "attendee-tech-check-toggle",
        label: "Attendee Tech Check",
        subLabel: "Require attendees to test their network strength and audio before entering the event.",
        class: "tw-mb-7",
        checked: _ctx.attendeeTechCheckEnabled,
        "onUpdate:checked": _ctx.handleAttendeeTechCheckToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "enter-event-button-toggle",
        label: "Allow Users to Enter Event Early",
        subLabel: "This setting cannot be changed less than one hour before the start of the event. Turn this setting off to prevent users from entering your event space. 60 minutes before the event starts, users will all be able to enter the event space. ",
        class: "tw-mb-7",
        checked: _ctx.enterEventButtonEnabled,
        title: 
          _ctx.isEnterEventButtonToggleDisabled
            ? 'This setting cannot be changed less than one hour before the start of the event'
            : ''
        ,
        disabled: _ctx.isEnterEventButtonToggleDisabled,
        "onUpdate:checked": _ctx.handleEnterEventButtonToggle
      }, null, 8, ["checked", "title", "disabled", "onUpdate:checked"]),
      (!_ctx.enterEventButtonEnabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_StudioToggleWithLabel, {
              id: "custom-cta-button-toggle",
              label: "Custom Call to Action",
              subLabel: "Include a button to link to the registration page or a custom URL.",
              class: "tw-mb-7",
              checked: _ctx.useCustomCtaButton,
              title: 
            _ctx.isEnterEventButtonToggleDisabled
              ? 'This setting cannot be changed less than one hour before the start of the event'
              : ''
          ,
              "onUpdate:checked": _ctx.handleCustomCtaButtonToggle
            }, null, 8, ["checked", "title", "onUpdate:checked"]),
            _createVNode(_component_StudioSelect, {
              id: "cta-link-select",
              label: "Link to",
              options: [
            { value: 'registration', label: 'Registration Page' },
            { value: 'custom', label: 'Custom URL' }
          ],
              size: "small",
              orientation: "horizontal",
              class: "tw-mb-4",
              disabled: !_ctx.useCustomCtaButton,
              value: _ctx.selectedCustomCtaButton,
              onChange: _ctx.handleLinkToChange
            }, null, 8, ["disabled", "value", "onChange"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_StudioInput, {
                id: "cta-button-text",
                label: "Button Text",
                class: "tw-mb-7",
                disabled: !_ctx.useCustomCtaButton,
                maxlength: 50,
                modelValue: _ctx.ctaButtonText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = value => _ctx.editCTAButtonText(value))
              }, null, 8, ["disabled", "modelValue"]),
              (_ctx.selectedCustomCtaButton === 'custom')
                ? (_openBlock(), _createBlock(_component_StudioInput, {
                    key: 0,
                    id: "cta-button-url",
                    label: "URL",
                    class: "tw-mb-7",
                    maxlength: 50,
                    modelValue: _ctx.ctaButtonUrl,
                    placeholder: "https://...",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = value => _ctx.editCTAButtonUrl(value))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}